const ReactGA = require('react-ga4').default;
const { pageview } = require('./src/services/analytics');

ReactGA.initialize('G-KG5H19H7YC');

exports.onRouteUpdate = (state, page, pages) => {
	pageview(state);
};
